<template>
  <b-modal
    id="modal-edit-renouvellement"
    size="xl"
    title="Modifier le renouvellement"
    title-class="modal__title modal__title--edit"
    @ok="putRenouvellement"
    @cancel="resetRenouvellementForm"
  >
    <b-form class="pt-2 px-md-3">

      <div class="alert alert-warning" role="alert" v-if="isSubstantielSelected">
        Merci de mettre à jour les caractéristiques/éoliennes/poste de livraison de votre parc en fonction des changements apportés par ce renouvellement.
      </div>

      <!-- Type de renouvellement -->
      <b-form-group
        label-cols-lg="3"
        label="Type de renouvellement"
        label-size="lg"
        label-class="fw-bold pt-0"
        class="mb-0"
      >
        <b-form-group
          id="input-group-types"
          label="Le parc a-t-il fait l'objet d'un renouvellement :"
          label-for="input-types"
          description="Veuillez sélectionner le type de renouvellement du parc"
        >
          <b-form-select
            id="input-types"
            v-model="selectedRenouvellementType"
            :options="renouvellementTypes"
            @change="onChangeTypeRenouvellement"
          />
        </b-form-group>
        <hr class="my-4" />
      </b-form-group>
      <!-- Dépôt du dossier de demande d'autorisation (ou du PC)-->
      <b-form-group
        label-cols-lg="3"
        label="Dépôt du dossier de demande d'autorisation (ou du PC)"
        label-size="lg"
        label-class="fw-bold pt-0"
        class="mb-0"
        v-if="isSubstantielSelected"
      >
        <b-form-group
          id="input-group-dateDepotDemandeAutorisation"
          label="Date de dépôt du dossier de demande d'autorisation auprès de la DREAL ou date du permis de construire pour les parcs éoliens qui bénéficient de l'antériorité"
          label-for="input-dateDepotDemandeAutorisation"
        >
          <b-form-input
            id="input-dateDepotDemandeAutorisation"
            v-model="selectedRenouvellementDateDepot"
            type="date"
            :max="todayDate"
            :state="validDateDepotDemandeAutorisation"
          >
          </b-form-input>
          <b-form-invalid-feedback v-if="!isDateDepotDemandeAutorisationFilled">
            La date de dépôt du dossier de demande d'autorisation (ou du PC) doit être renseignée
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!isDateDepotValid">
            La date ne doit pas être supérieure à la date du jour de la saisie
          </b-form-invalid-feedback>

        </b-form-group>
      </b-form-group>
      <!-- Date de délivrance de l'avis de l'autorité environnementale -->
      <b-form-group
        label-cols-lg="3"
        label="Date de délivrance de l'avis de l'autorité environnementale"
        label-size="lg"
        label-class="fw-bold pt-0"
        class="mb-0"
        v-show="isSubstantielSelected"
      >
        <b-form-group
          id="input-group-dateDelivranceAvisAutoriteEnvironnementale"
          label="Date de délivrance de l'avis de l'autorité environnementale"
          label-for="input-dateDelivranceAvisAutoriteEnvironnementale"
          class="mb-4"
        >
          <b-form-input
            id="input-dateDelivranceAvisAutoriteEnvironnementale"
            v-model="selectedRenouvellementDateDelivranceAvis"
            type="date"
            :max="todayDate"
            :state="validDateDelivranceAvisAutoriteEnvironnementale"
          ></b-form-input>
          <b-form-invalid-feedback v-if="!isDateDepotDemandeAutorisationFilled">
            La date de dépôt du dossier de demande d'autorisation (ou du PC) doit être renseignée
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!isDateDelivranceAvisValid">
            La date ne doit pas être supérieure à la date du jour de la saisie
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!(selectedRenouvellementDateDelivranceAvis >= selectedRenouvellementDateDepot)">
            Doit être supérieure à la date de dépôt du dossier de demande d'autorisation
            ({{ $filters.formatDate(selectedRenouvellementDateDepot) }})
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form-group>

      <!-- Arrêté d'autorisation ICPE -->
      <b-form-group
        label-cols-lg="3"
        label="Arrêté d'autorisation ICPE"
        label-size="lg"
        label-class="fw-bold pt-0"
        class="mb-0"
        v-show="isSubstantielSelected"
      >
        <b-form-group
          id="input-group-dateDelivranceAutorisationIcpe"
          label="Arrêté d'autorisation ICPE"
          label-for="input-dateDelivranceAutorisationIcpe"
          class="mb-4"
        >
          <b-form-input
            id="input-dateDelivranceAutorisationIcpe"
            v-model="selectedRenouvellementDateDelivranceAutorisationIcpe"
            type="date"
            :max="todayDate"
            :state="validDateDelivranceAutorisationIcpe"
          ></b-form-input>
          <b-form-invalid-feedback v-if="!isDateDelivranceAvisAutoriteEnvironnementaleFilled">
            La date de délivrance de l'avis de l'autorité environnementale doit être renseignée
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!isDateDelivranceAutorisationIcpeValid">
            La date ne doit pas être supérieure à la date du jour de la saisie
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!(selectedRenouvellementDateDelivranceAutorisationIcpe >= selectedRenouvellementDateDelivranceAvis)">
            Doit être supérieure à la délivrance de l'avis de l'autorité environnementale
            ({{ $filters.formatDate(selectedRenouvellementDateDelivranceAvis) }})
          </b-form-invalid-feedback>

        </b-form-group>
      </b-form-group>

      <!-- Déclaration d'ouverture du chantier de construction -->
      <b-form-group
        label-cols-lg="3"
        label="Déclaration d'ouverture du chantier de construction"
        label-size="lg"
        label-class="fw-bold pt-0"
        class="mb-0"
        v-show="isSubstantielSelected"
      >
        <b-form-group
          id="input-group-dateDeclarationOuvertureChantierConstruction"
          label="Déclaration d'ouverture du chantier de construction"
          label-for="input-dateDeclarationOuvertureChantierConstruction"
          class="mb-4"
        >
          <b-form-input
            id="input-dateDeclarationOuvertureChantierConstruction"
            v-model="selectedRenouvellementDateDeclarationOuvertureChantierConstruction"
            type="date"
            :max="todayDate"
            :state="validDateDeclarationOuvertureChantierConstruction"
          ></b-form-input>
          <b-form-invalid-feedback v-if="!isDateDelivranceAutorisationIcpeFilled">
            La date de l'arrêté d'autorisation ICPE doit être renseignée
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!isDateDeclarationOuvertureChantierValid">
            La date ne doit pas être supérieure à la date du jour de la saisie
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!(selectedRenouvellementDateDeclarationOuvertureChantierConstruction >= selectedRenouvellementDateDelivranceAutorisationIcpe)">
            Doit être supérieure à la date de délivrance de l'arrêté d'autorisation ICPE
            ({{ $filters.formatDate(selectedRenouvellementDateDelivranceAutorisationIcpe) }})
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form-group>

      <!-- Mise en service -->
      <b-form-group
        label-cols-lg="3"
        label="Mise en service"
        label-size="lg"
        label-class="fw-bold pt-0"
        class="mb-0"
        v-show="isSubstantielSelected"
      >
        <b-form-group
          id="input-group-dateMiseEnService"
          label="Mise en service"
          label-for="input-dateMiseEnService"
          class="mb-4"
        >
          <b-form-input
            id="input-dateMiseEnService"
            v-model="selectedRenouvellementDateMiseEnService"
            type="date"
            :max="todayDate"
            :state="validDateMiseEnService"
          ></b-form-input>
          <b-form-invalid-feedback v-if="!isDateDeclarationOuvertureChantierConstructionFilled">
            La date de l'arrêté d'autorisation ICPE doit être renseignée
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!isDateMiseEnServiceValid">
            La date ne doit pas être supérieure à la date du jour de la saisie
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!(selectedRenouvellementDateMiseEnService >= selectedRenouvellementDateDeclarationOuvertureChantierConstruction)">
            Doit être supérieure à la date de déclaration d'ouverture du chantier de construction
            ({{ $filters.formatDate(selectedRenouvellementDateDeclarationOuvertureChantierConstruction) }})
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form-group>

      <!-- Arrêté préfectoral complémentaire -->
      <b-form-group
        label-cols-lg="3"
        label="Arrêté préfectoral complémentaire"
        label-size="lg"
        label-class="fw-bold pt-0"
        class="mb-0"
        v-show="!isSubstantielSelected"
      >
        <b-form-group
          id="input-group-dateArretePrefectoralComplementaire"
          label="Date d'arrêté préfectoral complémentaire"
          label-for="input-dateArretePrefectoralComplementaire"
          class="mb-4"
        >
          <b-form-input
            id="input-dateArretePrefectoralComplementaire"
            v-model="selectedRenouvellementDateArretePrefectoralComplementaire"
            type="date"
            :max="todayDate"
            :state="validDateArretePrefectoralComplementaire"
          ></b-form-input>
          <b-form-invalid-feedback v-if="!isDateArretePrefectoralComplementaireFilled">
            La date de l'arrêté préfectoral complémentaire doit être renseignée
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-else-if="!isDateArretePrefectoralComplementaireValid">
            La date ne doit pas être supérieure à la date du jour de la saisie
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form-group>
    </b-form>
    <template #footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button
        variant="info"
        id="save-edit-renouvellement"
        @click="ok()"
        :disabled="disableRenouvellementSubmitButton"
      >
        Valider
        <b-tooltip target="#save-edit-renouvellement">
          Enregistrer le renouvellement
        </b-tooltip>
      </b-button>
      <b-button
        variant="default"
        id="cancel-edit-renouvellement"
        @click="cancel()"
      >
        Annuler
        <b-tooltip target="#cancel-edit-renouvellement">
          Revenir sur le panneau d'administration
        </b-tooltip>
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import {
  BModal,
  BButton,
  BFormInput,
  BFormSelect,
  BFormInvalidFeedback,
  BFormGroup,
  BForm,
  BTooltip
} from "bootstrap-vue-next";
import {useReactiveStoreGetters} from "@/composables/useStore";
import {computed, ref, watch} from "vue";
import {renouvellementService} from "@/service/renouvellement.service";
import store from "@/store";
import {commonService} from "@/service/common.service";
import {todayDate, isDateNotInFuture} from "@/util/date.util";

// Props
const {updateParc} = defineProps({updateParc: Function});
// MapGetters from store
const { renouvellement, parc } = useReactiveStoreGetters(['renouvellement', 'parc']);

// Émissions
const emit = defineEmits(['reload-parc'])

// Data
const selectedRenouvellementType = ref(null);
const selectedRenouvellementDateDepot = ref(null);
const selectedRenouvellementDateDelivranceAvis = ref(null);
const selectedRenouvellementDateDelivranceAutorisationIcpe = ref(null);
const selectedRenouvellementDateDeclarationOuvertureChantierConstruction = ref(null);
const selectedRenouvellementDateMiseEnService = ref(null);
const selectedRenouvellementDateArretePrefectoralComplementaire = ref(null);
const renouvellementTypes = [
    "Substantiel", "Notable"
];

// Watch pour synchroniser le type avec le store
watch(() => renouvellement.value?.type, (newType) => {
  if (newType) {
    selectedRenouvellementType.value = newType === "S" ? "Substantiel" : "Notable";
  }
}, { immediate: true });


const isSubstantielSelected = computed(() => selectedRenouvellementType.value === "Substantiel");
const isDateArretePrefectoralComplementaireFilled = computed(() => !!selectedRenouvellementDateArretePrefectoralComplementaire.value)
const isDateDepotDemandeAutorisationFilled = computed(() => !!selectedRenouvellementDateDepot.value)
const isDateDelivranceAvisAutoriteEnvironnementaleFilled = computed(() => !!selectedRenouvellementDateDelivranceAvis.value)
const isDateDelivranceAutorisationIcpeFilled = computed(() => !!selectedRenouvellementDateDelivranceAutorisationIcpe.value)
const isDateDeclarationOuvertureChantierConstructionFilled = computed(() => !!selectedRenouvellementDateDeclarationOuvertureChantierConstruction.value)
const isDateMiseEnServiceFilled = computed(() => !!selectedRenouvellementDateMiseEnService.value)


// Validations de date ne devant pas être supérieure à aujourd'hui
const isDateDepotValid = computed(() => isDateNotInFuture(selectedRenouvellementDateDepot.value));
const isDateDelivranceAvisValid = computed(() => isDateNotInFuture(selectedRenouvellementDateDelivranceAvis.value));
const isDateDelivranceAutorisationIcpeValid = computed(() => isDateNotInFuture(selectedRenouvellementDateDelivranceAutorisationIcpe.value));
const isDateDeclarationOuvertureChantierValid = computed(() => isDateNotInFuture(selectedRenouvellementDateDeclarationOuvertureChantierConstruction.value));
const isDateMiseEnServiceValid = computed(() => isDateNotInFuture(selectedRenouvellementDateMiseEnService.value));
const isDateArretePrefectoralComplementaireValid = computed(() => isDateNotInFuture(selectedRenouvellementDateArretePrefectoralComplementaire.value));

const validDateDepotDemandeAutorisation = computed(() => {
  if (!isDateDepotDemandeAutorisationFilled.value) {
    return null;
  }
  return isDateDepotValid.value;
})

const validDateDelivranceAvisAutoriteEnvironnementale = computed(() => {
  if (!isDateDelivranceAvisAutoriteEnvironnementaleFilled.value) {
    return null;
  }
  return isDateDelivranceAvisValid.value && isDateDepotDemandeAutorisationFilled.value && selectedRenouvellementDateDelivranceAvis.value >= selectedRenouvellementDateDepot.value;
})

const validDateDelivranceAutorisationIcpe = computed(() => {
  if (!isDateDelivranceAutorisationIcpeFilled.value) {
    return null;
  }
  return isDateDelivranceAutorisationIcpeValid.value && isDateDelivranceAvisAutoriteEnvironnementaleFilled.value &&
    selectedRenouvellementDateDelivranceAutorisationIcpe.value >= selectedRenouvellementDateDelivranceAvis.value;
})

const validDateDeclarationOuvertureChantierConstruction = computed(() => {
  if (!isDateDeclarationOuvertureChantierConstructionFilled.value) {
    return null;
  }
  return isDateDeclarationOuvertureChantierValid.value && isDateDelivranceAutorisationIcpeFilled.value &&
    selectedRenouvellementDateDeclarationOuvertureChantierConstruction.value >= selectedRenouvellementDateDelivranceAutorisationIcpe.value;
})

const validDateMiseEnService = computed(() => {
  if (!isDateMiseEnServiceFilled.value) {
    return null;
  }
  return isDateMiseEnServiceValid.value && isDateDeclarationOuvertureChantierConstructionFilled.value &&
    selectedRenouvellementDateMiseEnService.value >= selectedRenouvellementDateDeclarationOuvertureChantierConstruction.value;
})

const validDateArretePrefectoralComplementaire = computed(() => {
  if (!isDateArretePrefectoralComplementaireFilled.value) {
    return null;
  }
  return isDateArretePrefectoralComplementaireValid.value;
})

const disableRenouvellementSubmitButton = computed(() => {
  if (isSubstantielSelected.value) {
    return (
      validDateDepotDemandeAutorisation.value === false ||
      validDateDelivranceAvisAutoriteEnvironnementale.value === false ||
      validDateDelivranceAutorisationIcpe.value === false ||
      validDateDeclarationOuvertureChantierConstruction.value === false ||
      validDateMiseEnService.value === false
    );
  } else {
    return validDateArretePrefectoralComplementaire.value === false;
  }
})

// Methods
const onChangeTypeRenouvellement = (event) => {
  const value = event.target.value;
  selectedRenouvellementType.value = value;

  if (value === "Substantiel") {
    selectedRenouvellementDateArretePrefectoralComplementaire.value = null;
  } else {
    selectedRenouvellementDateDepot.value = null;
    selectedRenouvellementDateDelivranceAvis.value = null;
    selectedRenouvellementDateDelivranceAutorisationIcpe.value = null;
    selectedRenouvellementDateDeclarationOuvertureChantierConstruction.value = null;
    selectedRenouvellementDateMiseEnService.value = null;
  }
};

const putRenouvellement = async () => {
  // Vérifiez d'abord que renouvellement.value existe
  if (!renouvellement.value) {
    console.error('Renouvellement is undefined');
    return;
  }

  renouvellement.value.type = selectedRenouvellementType.value === "Substantiel" ? "S" : "N";
  renouvellement.value.dateDepotDemandeAutorisation = selectedRenouvellementDateDepot.value;
  renouvellement.value.dateDelivranceAvisAutoriteEnvironnementale = selectedRenouvellementDateDelivranceAvis.value;
  renouvellement.value.dateDelivranceAutorisationIcpe = selectedRenouvellementDateDelivranceAutorisationIcpe.value;
  renouvellement.value.dateDeclarationOuvertureChantierConstruction = selectedRenouvellementDateDeclarationOuvertureChantierConstruction.value;
  renouvellement.value.dateMiseEnService = selectedRenouvellementDateMiseEnService.value;
  renouvellement.value.dateArretePrefectoralComplementaire = selectedRenouvellementDateArretePrefectoralComplementaire.value;

  const response = await renouvellementService.putRenouvellement(renouvellement.value)
  addNotification(response);
  await updateParc(renouvellement.value.parc);
  emit('reload-parc');

  resetRenouvellementForm();
}

const addNotification = (response) => {
  if (response) {
    if (response.status === 200) {
      response.text().then(message => {
        const notificationTextMessage = message;
        const notificationIcon = "ti-check";
        const notificationType = "success";

        store.dispatch("saveTextNotification", {
          notificationIcon,
          notificationType,
          notificationTextMessage
        });
      });
    } else if (response.status === 400) {
      response.json().then(message => {
        store.dispatch("saveJsonNotification", {
          notificationTitle: "Les modifications n'ont pas été prises en compte",
          notificationIcon: "ti-alert",
          notificationType: "danger",
          notificationJsonMessage: message
        });
      });
    } else {
      commonService.handleUnsuccessfulResponse(response);
    }
  } else {
    commonService.handleNoResponse();
  }
}

const formatDate = (value) => {
  const date = new Date(value);

  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (month < 10) month = "0" + month;
  if (day < 10) day = "0" + day;

  return [date.getFullYear(), month, day].join("-");
};

// Pré-selection des input select avec les valeurs de l'objet renouvellement
const setRenouvellementDate = (dateField, dateValue) => {
  if (renouvellement.value != null && dateValue != null) {
    dateField.value = formatDate(dateValue);
  }
};

// Préparation du formulaire de modification
const prepareEdit = (renouvellement) => {
  store.dispatch("saveRenouvellement", renouvellement);

  selectedRenouvellementType.value = renouvellement.type === "S" ? "Substantiel" : "Notable";
  selectedRenouvellementDateDepot.value = null;
  selectedRenouvellementDateDelivranceAvis.value = null;
  selectedRenouvellementDateDelivranceAutorisationIcpe.value = null;
  selectedRenouvellementDateDeclarationOuvertureChantierConstruction.value = null;
  selectedRenouvellementDateMiseEnService.value = null;
  selectedRenouvellementDateArretePrefectoralComplementaire.value = null;

  setRenouvellementDate(selectedRenouvellementDateDepot, renouvellement.dateDepotDemandeAutorisation);
  setRenouvellementDate(selectedRenouvellementDateDelivranceAvis, renouvellement.dateDelivranceAvisAutoriteEnvironnementale);
  setRenouvellementDate(selectedRenouvellementDateDelivranceAutorisationIcpe, renouvellement.dateDelivranceAutorisationIcpe);
  setRenouvellementDate(selectedRenouvellementDateDeclarationOuvertureChantierConstruction, renouvellement.dateDeclarationOuvertureChantierConstruction);
  setRenouvellementDate(selectedRenouvellementDateMiseEnService, renouvellement.dateMiseEnService);
  setRenouvellementDate(selectedRenouvellementDateArretePrefectoralComplementaire, renouvellement.dateArretePrefectoralComplementaire);
  setRenouvellementDate(selectedRenouvellementDateDeclarationOuvertureChantierConstruction, renouvellement.dateDebutConstruction);
};

const resetRenouvellementForm = () => {
  store.dispatch('saveRenouvellement', { parc: renouvellement.value.parc, type: isSubstantielSelected.value ? 'S' : 'N', dateRenouvellement: new Date() });
}

// Exposer la méthode
defineExpose({ prepareEdit })

</script>
